<div class="modal-dialog">
  <div class="modal-content">
    <div class="modal-header">{{ data.headline }}</div>

    <div [formGroup]="form" class="modal-body cl-form">
      <div>
        <label class="form-label" for="tag_key">Key<span class="required">*</span></label>
        <input [class.invalid]="keyMissing" class="it-tag-field-key" formControlName="key" id="tag_key" type="text">
        @if (keyMissing) {
          <p class="invalid-feedback d-block it-tag-key-error">Enter a key.</p>
        } @else {
          <p class="valid-feedback d-block">The name of the tag.</p>
        }
      </div>

      <div class="cl-spacing-small">
        <label class="form-label" for="tag_value">Value</label>
        <input class="it-tag-field-value" formControlName="value" id="tag_value" type="text">
        <p class="valid-feedback d-block">The text stored with the key. It can be empty.</p>
      </div>
    </div>

    <div class="modal-footer">
      <span class="modal-footer-left">
        <button (click)="dialogRef.close(undefined)" class="btn cl-color-secondary it-cancel" type="button">
          <span>Cancel</span>
        </button>
      </span>
      <span class="modal-footer-center"></span>
      <span class="modal-footer-right">
        <button (click)="confirm()" [disabled]="form.invalid" class="btn cl-color-primary it-ok" type="button">
          <span>{{ data.actionName }}</span>
        </button>
      </span>
    </div>
  </div>
</div>
